export default "__VITE_ASSET__aaXXPY6w__"